export default __webpack_public_path__ + "static/media/img_baseBunnyRattle_green.5747bebd.jpg";